import * as React from 'react'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { safeBoolean } from '../../utils/utils'
import { DpWidgetContext } from '../../utils/dpWidgetContext'
import * as st from './ad.module.scss'


export interface AdBadgeProps {
  isAd?: boolean
}

export const Ad = ({ isAd }: AdBadgeProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  return safeBoolean(isAd) &&
  (<span data-automation-id="ad-badge" className={st.adLogo} title={getString('DV_DP_ARIA_audio_description')}
         aria-label={getString('DV_DP_ARIA_audio_description')}>
    <Icon use={IconType.AUDIO_DESCRIPTION} />
  </span>) || null
}
